// ProfileCategories.js
'use strict';
import { connect } from 'react-redux';

import ProfileCategories from '../component/ProfileCategories.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsCategoryEmpty from '../selector/getIsCategoryEmpty.js';

const mapStateToProps = (state, { userId, remoteConfigKey }) => {
  const categories = getRemoteConfigData(state, remoteConfigKey, undefined, {
    USER_ID: userId,
  });
  return {
    isFetchedAndEmpty: getIsCategoryEmpty(state, categories),
    categoryTemplates: getRemoteConfigData(state, remoteConfigKey),
    categories,
  };
};

export default connect(mapStateToProps, null)(ProfileCategories);
